import axios from "axios";

//IMPORT API ROUTE URL
import { GET_MY_RECOMMENDATION_ROUTE } from "./apiRoutes";

const getMyRecommendations = (user_slug) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);

  return axios
    .post(GET_MY_RECOMMENDATION_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getMyRecommendations;
